export default {
  path: '/home',
  name: 'home',
  component: resolve => require(['@/views/home'], resolve),
  meta: {
    keepAlive: true,
    title: '首页',
    sidebar: false,
    permission: 'homePage',
    activeName: '/home',
    name: 'home'
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/home.js